export default {
  /**
   * 사용법
   * 
   * 마크업은 다음과 같이 작성한다 (config, fileSelected 는 변경 가능)
   * <google-drive :config="config" @picked="fileSelected">구글</google-drive>
   * 선언부
   * components: {
   *   "google-drive" : GoogleDrive
   * }
   * 데이터는 다음과 같이 작성한다 (데이터명 config 는 변경가능, developerKey, clientId, appId 는 구글 계정에서 생성)
   * data() {
   *   return() {
   *     config: {
   *       developerKey: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
   *       clientId: "111111111111-aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa.apps.googleusercontent.com",
   *       appId: "111111111111",
   *       scope: "https://www.googleapis.com/auth/drive.file"
   *     }
   *   }
   * }
   * 메소드는 다음과 같이 작성한다. (함수명 fileSelected 는 변경가능)
   * methods: {
   *   fileSelected(data) {
   *     if(data.action === "picked") {
   *       console.log(data.docs);
   *     }
   *   }
   * }
   * 
   */
  template: `<button @click="handleButtonClick" :disabled="!pickerApiLoaded"><slot/></button>`,
  props: ["config"],
  data() {
    return {
      picked: {},
      pickerApiLoaded: false,
      oauthToken: "",
      initStatus: 0,
      GDIALOG_SELECTOR: "div.picker.picker-dialog iframe.picker-frame.picker-dialog-frame"
    }
  },
  methods: {
    handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token
        this.createPicker()
      } else {
        return console.warn(authResult.details)  
      }      
    },
    handleButtonClick(e) {
        window.gapi.auth2.authorize({
          client_id: this.config.clientId,
          scope: (this.config.scope ? this.config.scope : "https://www.googleapis.com/auth/drive.file"),
          immediate: false
        }, this.handleAuthResult);
        this.$emit("click", e);
    },
    createPicker () {
      if (this.pickerApiLoaded && this.oauthToken) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        /** 
         * 파일종류 필터링
         * view.setMimeTypes("image/png,image/jpeg,image/jpg"); 
         * */
        const picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.NAV_HIDDEN)
          /**
           * 다중파일 선택
           * .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
           */
          .setAppId(this.config.appId)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(this.config.developerKey)
          .addView(view)
          .setCallback(this.pickerCallback)
          .build();
        picker.setVisible(true);
      }
    },
    pickerCallback(data) {
      let close = false;
      if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
        this.$emit("picked", data);
        close = true;
      } else 
      if (data[google.picker.Response.ACTION] === "loaded") {
          let dialog = document.querySelector(this.GDIALOG_SELECTOR);
          let style = dialog.style;
          style.height = "100%";
      } else 
      if (data[google.picker.Response.ACTION] === "cancel") {
        close = true;
      }
      if (close) {
        let dialog = document.querySelector(this.GDIALOG_SELECTOR);
        if (dialog) {
          dialog.remove();
        }
      }
    },
    initGAPI() {
      if (this.pickerApiLoaded) { 
        return;
      }
      else if (window.gapi) {
        if (this.initStatus < 2) {
          this.initStatus = 2;
          /* API 초기화 */
          window.gapi.load("auth2");
          window.gapi.load("picker", () => { this.pickerApiLoaded = true });
        }
      }
      else {
        if (this.initStatus < 1) {
          this.initStatus = 1;
          /* 구글 API 스크립트 임포트 */
          let script = document.createElement("script");
          script.src = "https://apis.google.com/js/api.js";
          document.body.appendChild(script);
        }
      }
      if (!this.pickerApiLoaded) {
        setTimeout(this.initGAPI, 100);
      }
    }
  },
  mounted () {
    this.initGAPI();
  }    
}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/extensions/GoogleDrive.js